import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

import type { DocumentStatus } from '@/types/document.types';

interface DocumentStatusBadgeProps {
  status: DocumentStatus;
}

const STATUS_STYLES: Record<DocumentStatus, string> = {
  uploaded: 'bg-blue-100 text-blue-800',
  flagged: 'bg-orange-100 text-orange-800',
  verified: 'bg-green-100 text-green-800',
  rejected: 'bg-red-100 text-red-800',
};

export function DocumentStatusBadge({ status }: DocumentStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold',
        STATUS_STYLES[status],
      )}>
      {t(`documents.statuses.${status}`)}
    </span>
  );
}
